import React from 'react'
import Table from '../../components/common/Table'
import { InvoiceTypeDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'

interface InvoiceTypeTableProps {
  data: InvoiceTypeDTO[];
  handleEdit: (row: InvoiceTypeDTO) => void;
  handleDelete: (row: InvoiceTypeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const InvoiceTypeTable: React.FC<InvoiceTypeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
                
                    {
                        label: "Name",
                        key: "name",
                    },
        
                    {
                        label: "Description",
                        key: "description",
                    },
        
                    {
                        label: "Prefix",
                        key: "prefix",
                    },
        
                    {
                        label: "Last Used Number",
                        key: "lastUsedNumber",
                    },
        
                {
                    label: "Added",
                    key: "createdUtc",
                    format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
                },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default InvoiceTypeTable;
